import { useContext, useState, useRef, useEffect } from 'react';
import Scrollbar from '../../../components/Scrollbar';
import { SidebarContext } from '../../../contexts/SidebarContext';
import { useLocation } from 'react-router-dom';

import {
  Box,
  Drawer,
  styled,
  Divider,
  useTheme,
  darken,
} from '@mui/material';

import SidebarMenu from './SidebarMenu';
import Logo from '../../../components/LogoSign';



const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        border-right:1px solid rgb(230, 227, 227);
        z-index: 7;
        height: 100%;
        padding-bottom: 0px;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const location = useLocation();
  const scrollbarRef = useRef<any>(null);
  const SCROLL_KEY = 'sidebar-scroll';

  // Save scroll position on scroll
  const handleScroll = () => {
    if (scrollbarRef.current) {
      const scrollTop = scrollbarRef.current.getScrollTop();
      sessionStorage.setItem(SCROLL_KEY, scrollTop.toString());
    }
  };

  // Restore scroll position after navigation
  useEffect(() => {
    const savedScroll = sessionStorage.getItem(SCROLL_KEY);
    if (scrollbarRef.current && savedScroll) {
      const scrollTop = parseInt(savedScroll, 10);
      // Use requestAnimationFrame for better timing
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (scrollbarRef.current) {
            scrollbarRef.current.scrollTop(scrollTop);
          }
        }, 0);
      });
    }
  }, [location.pathname]);

  return (
    <>
      <SidebarWrapper
        sx={{
          display: 'inline-block',
          position: 'fixed',
          left: 0,
          top: 0,
          background: 'white',
        }}
      >
        <Scrollbar ref={scrollbarRef} onScroll={handleScroll}>
          <Box
            sx={{
              pt: theme.spacing(2.4),
              pb: theme.spacing(2.2),
              borderBottom: 1,
              borderBottomColor: '#E6E3E3',
            }} >
            <Box
              mx={2}
              sx={{
                width: 52
              }}
            >
              <Logo />
            </Box>
          </Box>

          <SidebarMenu />
        </Scrollbar>

      </SidebarWrapper>
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5),
          }}
        >
          <Scrollbar>
            <Box mt={3}>
              <Box
                mx={2}
                sx={{
                  width: 52,
                }}
              >
                <Logo />
              </Box>
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.black[10],
              }}
            />
            <SidebarMenu />
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
      

    </>
  );
}

export default Sidebar;